/**
 * Helper to safely extract error messages from API responses
 * Handles Pydantic validation arrays, simple strings, and generic fallbacks
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  try {
    if (!error.response) return defaultMessage;

    const data = error.response.data;
    
    // Handle Pydantic Validation Errors (Array of objects)
    if (data?.detail && Array.isArray(data.detail)) {
      const firstError = data.detail[0];
      if (firstError && typeof firstError.msg === 'string') {
        return firstError.msg.replace('Value error, ', '');
      }
      if (typeof firstError === 'string') {
        return firstError;
      }
      // If firstError is an object but doesn't have msg, return default or JSON
      return JSON.stringify(firstError);
    }

    // Handle Simple String Error
    if (data?.detail && typeof data.detail === 'string') {
      return data.detail;
    }

    // Handle nested message objects if any
    if (data?.message && typeof data.message === 'string') {
      return data.message;
    }

    return defaultMessage;
  } catch (e) {
    console.error("Error parsing error message:", e);
    return defaultMessage;
  }
};
